import moment from "moment-timezone";

import { DIAGNOSTIC_INTERVIEW_90791 } from "@/components/Provider/ScheduleAvailability/constants";
import type { Provider } from "@/core/types";

export const buildCallTitle = (providerRole: Provider, event_type: string): string => {
  if (event_type === DIAGNOSTIC_INTERVIEW_90791) {
    return "Therapy Consultation";
  }

  if (providerRole === "PRESCRIBE") {
    return "Medication Management Session";
  }

  return "Therapy Session";
};

export const buildCallDate = (timestamp: string): string => {
  const localTimestamp = moment.utc(timestamp, "YYYY-MM-DD HH:mm").local();
  const dayOfWeek = localTimestamp.isSame(moment(), "day")
    ? "Today"
    : localTimestamp.format("dddd");

  const startDateTime = localTimestamp.format("MMMM D");

  return `${dayOfWeek}, ${startDateTime}`;
};

export const buildCallTimeInfo = (timestamp: string, allottedTime: number): string => {
  const localTimestamp = moment.utc(timestamp, "YYYY-MM-DD HH:mm").local();
  const startTime = localTimestamp.format("h:mm a");
  const endTime = localTimestamp.add(allottedTime, "minutes").format("h:mm a");

  return `${startTime} - ${endTime}`;
};
